/*
 * Páginas do tema que outra extensão já ocupa cedem o lugar, como as rotas do
 * backend (src/Support/GuardedRouteCollection.php).
 *
 * O roteador do Flarum monta a tabela pelo caminho: com duas rotas em
 * `/badges` (a do tema e a do fof/badges), vale a última registrada, e o
 * servidor e o navegador podiam escolher páginas diferentes. Aqui, antes de o
 * app montar o roteador, cada rota `canela.*` cujo caminho outra extensão
 * também registra passa a apontar para a rota dela: o caminho fica com a
 * outra extensão, e os links do tema (`app.route('canela.badges')`) continuam
 * funcionando, levando à página dela.
 *
 * Algumas páginas têm um endereço reserva: com o fof/badges, as do tema mudam
 * de `/badges` para `/achievements` (o mesmo do servidor, extend/badges.php)
 * e continuam no ar. A mudança vem antes da cessão, então só cedem as rotas
 * que ainda colidem.
 */
import app from 'flarum/forum/app';
import { isExtensionEnabled } from './settings';
/** Endereços reserva: com a extensão ligada, o prefixo do caminho troca. */
const RELOCATIONS = [{
  extension: 'fof-badges',
  routes: ['canela.badges', 'canela.badge', 'canela.badge.short', 'canela.user.badges'],
  from: /\/badges(?=\/|$)/,
  to: '/achievements'
}];
export function relocateRoutes(routes = app.routes, enabled = isExtensionEnabled) {
  const moved = [];
  for (const {
    extension,
    routes: names,
    from,
    to
  } of RELOCATIONS) {
    if (!enabled(extension)) continue;
    for (const name of names) {
      const route = routes[name];
      if (!route?.path || !from.test(route.path)) continue;
      routes[name] = {
        ...route,
        path: route.path.replace(from, to)
      };
      moved.push(name);
    }
  }
  return moved;
}
export function yieldConflictingRoutes(routes = app.routes) {
  const byPath = new Map();
  for (const [name, route] of Object.entries(routes)) {
    if (!route?.path) continue;
    const names = byPath.get(route.path) ?? [];
    names.push(name);
    byPath.set(route.path, names);
  }
  const yielded = [];
  for (const names of byPath.values()) {
    const theirs = names.filter(name => !name.startsWith('canela'));
    if (!theirs.length) continue;
    for (const name of names) {
      if (!name.startsWith('canela')) continue;
      routes[name] = routes[theirs[0]];
      yielded.push(name);
    }
  }
  return yielded;
}
flarum.reg.add('ramon-canela', 'forum/utils/routeConflicts', { relocateRoutes: relocateRoutes,yieldConflictingRoutes: yieldConflictingRoutes, });